export class FiltrosCobranza{
   Proveedor : any;
   Adquirente : any;
   TipoMoneda : any = [];
   TipoBanco : any = [];
   TipoPago : any = [];
   FechaInicio : any;
   FechaFin : any;
   Estado : any;
}
